import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { ClientAuthProvider } from "./context/ClientAuthContext";
import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import LeCoach from "./pages/LeCoach";
import Tarifs from "./pages/Tarifs";
import CreditImpot from "./pages/CreditImpot";
import Reservation from "./pages/Reservation";
import Success from "./pages/Success";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ClientLogin from "./pages/ClientLogin";
import ClientRegister from "./pages/ClientRegister";
import ClientAccount from "./pages/ClientAccount";
import MentionsLegales from "./pages/MentionsLegales";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";
import UniversMassages from "./pages/UniversMassages";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminReservations from "./pages/AdminReservations";
import AdminContacts from "./pages/AdminContacts";
import AdminContent from "./pages/AdminContent";
import AdminBlog from "./pages/AdminBlog";
import AdminClients from "./pages/AdminClients";
import AdminClientDetail from "./pages/AdminClientDetail";
import AdminNotificationsHistory from "./pages/AdminNotificationsHistory";
import AdminPlanning from "./pages/AdminPlanning";
import AdminSettings from "./pages/AdminSettings";
import AdminEmailHistory from "./pages/AdminEmailHistory";

function Public({ children }) {
  return <PublicLayout>{children}</PublicLayout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ClientAuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-right" toastOptions={{
              style: { background: "#ffffff", border: "1px solid #e5e5e5", color: "#2c2c2c" }
            }} />
            <Routes>
              <Route path="/" element={<Public><Home /></Public>} />
              <Route path="/le-coach" element={<Public><LeCoach /></Public>} />
              <Route path="/tarifs" element={<Public><Tarifs /></Public>} />
              <Route path="/credit-impot" element={<Public><CreditImpot /></Public>} />
              <Route path="/reservation" element={<Public><Reservation /></Public>} />
              <Route path="/reservation/success" element={<Public><Success /></Public>} />
              <Route path="/contact" element={<Public><Contact /></Public>} />
              <Route path="/blog" element={<Public><Blog /></Public>} />
              <Route path="/blog/:slug" element={<Public><BlogPost /></Public>} />

              <Route path="/account/login" element={<Public><ClientLogin /></Public>} />
              <Route path="/account/register" element={<Public><ClientRegister /></Public>} />
              <Route path="/account" element={<Public><ClientAccount /></Public>} />
              <Route path="/account/reservations" element={<Public><ClientAccount /></Public>} />

              <Route path="/mentions-legales" element={<Public><MentionsLegales /></Public>} />
              <Route path="/cgv" element={<Public><CGV /></Public>} />
              <Route path="/confidentialite" element={<Public><Confidentialite /></Public>} />

              <Route path="/univers/massages" element={<Public><UniversMassages /></Public>} />
              <Route path="/massages" element={<Public><UniversMassages /></Public>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="reservations" element={<AdminReservations />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="clients/:id" element={<AdminClientDetail />} />
                <Route path="contacts" element={<AdminContacts />} />
                <Route path="notifications" element={<AdminNotificationsHistory />} />
                <Route path="planning" element={<AdminPlanning />} />
                <Route path="parametres" element={<AdminSettings />} />
                <Route path="emails" element={<AdminEmailHistory />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="blog" element={<AdminBlog />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ClientAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
